// packages/world-model/src/traits/switchable/index.ts

export * from './switchableTrait';
export * from './switchableBehavior';